/**
 * BaseLayout Component
 * 
 * Základný layout pre všetky stránky.
 * Obsahuje navigáciu, main content a footer.
 */

import { ReactNode } from 'react';
import { MainNavigation } from '@/components/navigation/MainNavigation';
import { Footer } from '@/components/layout/Footer';
import { AnnouncementBar } from '@/components/home/AnnouncementBar';
import { announcementMessages } from '@/data/homeData';

interface BaseLayoutProps {
  children: ReactNode;
  /** Zobraz announcement bar */
  showAnnouncement?: boolean;
  /** Typ footera - full obsahuje newsletter, simple len registráciu */
  footerVariant?: 'full' | 'simple';
  /** Zobraz navigáciu */
  showNavigation?: boolean;
  /** Zobraz footer */
  showFooter?: boolean;
  /** Vlastná CSS trieda pre main element */
  mainClassName?: string;
}

export const BaseLayout = ({
  children,
  showAnnouncement = true,
  footerVariant = 'full',
  showNavigation = true,
  showFooter = true,
  mainClassName = '',
}: BaseLayoutProps) => {
  return (
    <div className="min-h-screen bg-background flex flex-col has-bottom-nav">
      {showAnnouncement && <AnnouncementBar messages={announcementMessages} />}
      {showNavigation && <MainNavigation />}
      
      <main className={`flex-1 ${mainClassName}`}>
        {children}
      </main>

      {showFooter && <Footer variant={footerVariant} />}
    </div>
  );
};

export default BaseLayout;
